export default {
  showModal: ({ commit }, { type, props = {} }) => {
    commit('SHOW_MODAL', { type, props })
  },
  hideModal: ({ commit }) => commit('HIDE_MODAL'),
}
